import { render, staticRenderFns } from "./RentStatusBase.vue?vue&type=template&id=645ec6d8&scoped=true"
import script from "./RentStatusBase.vue?vue&type=script&lang=js"
export * from "./RentStatusBase.vue?vue&type=script&lang=js"
import style0 from "./RentStatusBase.vue?vue&type=style&index=0&id=645ec6d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645ec6d8",
  null
  
)

export default component.exports